<template>
  <div>
    
    <h1>Associar Opções de Tratativas</h1>

    <div class="container-dados-usuario" 
      v-if="!loadingTratativasOpcoes && listaDadosAssociados.length || listaDadosDisponiveis.length">
      <h5>Tarefa: <small>{{ tarefaMobilidade.tarefa }}</small> </h5>
    </div>

    <div class="mcontainer-fluid">
      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPAssociarComponent
            v-if="(listaDadosAssociados.length || listaDadosDisponiveis.length)"
            tituloAssociados="Opções Tratativas"
            tituloDisponiveis="Opções Tratativas"
            :dadoAssociado="listaDadosAssociados"
            :dadoDisponivel="listaDadosDisponiveis"
            @sgpSalvarAssociacoesEmit="opcoesTratativasParaAssociar"
            @change="atualizarListas($event)"
          />
        </div>
      </div> 
    </div>
    <SGPLoadingComponent v-if="loadingTratativasOpcoes" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TarefaOpcaoTratativaAssociacaoPage',

  data () {
    return {
      listaDadosAssociados: [],
      listaDadosDisponiveis: []
    }
  },

  async created () {
    await this.listarTarefasComFiltro({
      ativo: 1
    });
    await this.listarOpcoesTratativas();
    await this.recuperarTarefa({ id: parseInt(this.$route.params.tarefa) });

    this.atualizarListaDeDadosAssociadosENaoAssociados();
  },

  computed: {
    ...mapGetters('ctrlTarefas', ['listaDeTarefasAtivas', 'tarefaSelecionada', 'tarefaOpcaoTratativa']),
    ...mapGetters('ctrlTratativasOpcoes', ['listaDeTratativasOpcoes', 'loadingTratativasOpcoes']),
   
    tarefaMobilidade () {
      return this.tarefaSelecionada;
    },

    opcoesTratativasAssociadas () {      
      let itensAssociados = [];
      
      if(this.tarefaSelecionada.id) {
        const listaDeItemsAssociados = this.tarefaSelecionada.ctrl_tarefa_tratativa_opcao.map(item => item.ctrl_tratativa_opcao_id);
  
        itensAssociados =  this.tarefaOpcaoTratativa.filter(item => {
          return listaDeItemsAssociados.includes(item.id)
        }).map(item => {
          return {
            id: item.id,
            descricao: item.opcao,
            selecionado: false
          }
        })
      } 

      return itensAssociados;
    },

    opcoesTratativasDisponiveis () {
      let itensDisponiveis = [];
      
      if(this.tarefaSelecionada.id) {
        const listaDeItemsAssociados = this.tarefaSelecionada.ctrl_tarefa_tratativa_opcao.map(item => item.ctrl_tratativa_opcao_id);
  
        itensDisponiveis =  this.tarefaOpcaoTratativa.filter(item => {
          return !listaDeItemsAssociados.includes(item.id)
        }).map(item => {
          return {
            id: item.id,
            descricao: item.opcao,
            selecionado: false
          }
        })
      }

      return itensDisponiveis;
    },
  },

  methods: {
    ...mapActions('ctrlTarefas', [
      'recuperarTarefa', 
      'listarTarefasComFiltro', 
      'listarOpcoesTratativas',
      'associarOpcoesTratativas'
    ]),

    atualizarListas(event) {
      if(typeof event == 'undefined'){
        return false;
      }
      this.atualizarListaDeDadosAssociadosENaoAssociados();
    },
    
    atualizarListaDeDadosAssociadosENaoAssociados () {
      this.listaDadosAssociados = this.opcoesTratativasAssociadas
      this.listaDadosDisponiveis = this.opcoesTratativasDisponiveis
    },

    async opcoesTratativasParaAssociar (value) {
      const listaIdsAssociados = value.listaAssociados.map(item => {
        return item.id
      })

      const payload = {
        ctrl_tarefa_id: this.$route.params.tarefa,
        opcoesTratativas: listaIdsAssociados
      }

      this.associarOpcoesTratativas(payload);
    }
  },

  watch: {
    opcoesTratativasDisponiveis(){
      this.atualizarListaDeDadosAssociadosENaoAssociados(); 
    }
  },
}
</script>
